document.addEventListener("DOMContentLoaded", function () {
  gsap.set(".co-os-s2-text .z-ani-o", { opacity: 0, y: 40 });
  let cOsS2Tl1 = gsap.timeline({ paused: true });
  cOsS2Tl1.to(
    ".co-os-s2-text .z-ani-o",
    {
      y: 0,
      scale: 1,
      opacity: 1,
      duration: 1,
      stagger: 0.2,
      ease: "power2.inOut",
    },
    "-=0.9"
  );
  ScrollTrigger.create({
    trigger: ".co-os-s2-text .z-ani-o",
    start: "40% bottom",
    end: "bottom top",
    animation: cOsS2Tl1,
  });

  document.querySelectorAll(".co-os-s2-item").forEach((item) => {
    const anim = item.querySelectorAll(".z-ani-o");
    // const items = container.querySelectorAll(".co-home-s5-bottom-cell-item");

    gsap.set(anim, { opacity: 0, y: 40 });
    let cOsS2Tl2 = gsap.timeline({ paused: true });
    cOsS2Tl2.to(
      anim,
      {
        y: 0,
        scale: 1,
        opacity: 1,
        duration: 1,
        stagger: 0.2,
        ease: "power2.inOut",
      },
      "-=0.9"
    );
    ScrollTrigger.create({
      trigger: anim,
      start: "40% bottom",
      end: "bottom top",
      animation: cOsS2Tl2,
    });
  });
});
